import {
  Box,
  Button,
  Grid,
  MenuItem,
  Modal,
  Select,
  TextField,
  Typography
} from '@mui/material';
import moment from 'moment';
import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import {
  addCompanyLeave,
  getLeaveTypes,
  updateCompanyLeave
} from 'src/services/yearPlannerService';
import { AppActions } from 'src/store/AppReducer';
import CancelIcon from '@mui/icons-material/Cancel';
import ConfirmationModal from '../common/confirmationModal/ConfirmationModal';
import { useAppSelector } from 'src/hooks/hooks';

interface Props {
  show: boolean;
  handleClose: () => void;
  date: any;
  event: any;
  description: any;
  data: any;
  isEdit: boolean;
}
const AddLeaveModal = (props: Props) => {
  const dispatch = useDispatch();
  const { isLoading } = useAppSelector((state) => state.appReducer);

  const [openConfirmation, setOpenConfirmation] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [description, setDescription] = useState('');
  const [errors, setErrors] = useState<any>({
    nameError: '',
    dayTypeError: '',
    leaveTypeError: ''
  });
  const [leaveTypes, setLeaveTypes] = useState([]);
  const [selectLeaveType, setSelectLeaveType] = useState({ id: null, description: '' });
  const [selectDayType, setDayLeaveType] = useState('');
  const [selectHoliday, setSelectHoliday] = useState([]);
  const [selectHolidayLocal, setSelectHolidayLocal] = useState([]);
  const [selectHolidayOperation, setSelectHolidayOperation] = useState([]);

  //All day type value
  const dayTypes = [
    { label: 'Full day', value: '0' },
    { label: 'Half day- Morning ', value: '1' },
    { label: 'Half day- Evening', value: '2' }
  ];

  const toggleConfirmation = () => {
    setOpenConfirmation(!openConfirmation);
  };

  // On Edit view Loading the Calander
  useEffect(() => {
    if (props.isEdit) {
      const matchingData = props.data.filter(item => item.date === props.date);

      const realData = [...selectHoliday];
      const localData = [...selectHolidayLocal];
      const holidayOperationData = [];
      
      if (matchingData?.length > 0) {
        matchingData.map((element) => {
          const filterHolidayType = leaveTypes.filter(
            (item) => item.id === element.calendarTypeId
          );
          const filterDayType = dayTypes.filter(
            (item) => item.label === element.dayType
          );
    
          const currentHoliday = {
            eventDate: element.eventDate,
            calendarTypeId: filterHolidayType[0].id,
            calendarType: filterHolidayType[0].description,
            description: element.description,
            dayType: parseInt(filterDayType[0].value, 10)
          };
    
          const currentHolidayLocalArr = {
            calendarTypeId: filterHolidayType[0].id,
            calendarType: filterHolidayType[0].description,
            description: element.description,
            dayType: filterDayType[0].label
          };

          //update purpose
          const holidayOperation = {
            id: element.id,
            eventDate: moment(element.eventDate).format("YYYY-MM-DD"),
            calendarTypeId: filterHolidayType[0].id,
            calendarType: filterHolidayType[0].description,
            description: element.description,
            dayType: parseInt(filterDayType[0].value, 10),
            Operation: 'Update'
          };
    
          realData.push(currentHoliday);
          setSelectHoliday(realData);
          localData.push(currentHolidayLocalArr);
          setSelectHolidayLocal([...localData]);
          holidayOperationData.push(holidayOperation);
          setSelectHolidayOperation(holidayOperationData);
        })
      }
      
    }
  }, [props.isEdit]);

  // On Insert view Loading the Calander
  const addLeave = () => {
    if (selectHoliday.some((item) => item.calendarTypeId === selectLeaveType.id)) {
      setErrors((prev) => ({
        ...prev,
        leaveTypeError: 'Duplicate Holiday Type'
      }));
    } else if (
      selectLeaveType.id &&
      description &&
      selectDayType &&
      description.length < 31
    ) {
      setErrors((prev) => ({
        ...prev,
        leaveTypeError: ''
      }));

      const realData = [...selectHoliday];
      const localData = [...selectHolidayLocal];
      const holidayOperationData = [...selectHolidayOperation];

      const filterHolidayType = leaveTypes.filter(
        (item) => item.id === selectLeaveType.id
      );
      const filterDayType = dayTypes.filter(
        (item) => item.value === selectDayType
      );

      const currentHoliday = {
        eventDate: props.date,
        calendarTypeId: selectLeaveType.id,
        calendarType: selectLeaveType.description,
        description: description,
        dayType: parseInt(selectDayType, 10)
      };

      const currentHolidayLocalArr = {
        calendarTypeId: filterHolidayType[0].id,
        calendarType: filterHolidayType[0].description,
        description: description,
        dayType: filterDayType[0].label
      };

      //update purpose
      const holidayOperation = {
        eventDate: props.date,
        calendarTypeId: selectLeaveType.id,
        calendarType: selectLeaveType.description,
        description: description,
        dayType: parseInt(selectDayType, 10),
        Operation: 'Add'
      };

      realData.push(currentHoliday);
      setSelectHoliday(realData);
      localData.push(currentHolidayLocalArr);
      setSelectHolidayLocal([...localData]);
      holidayOperationData.push(holidayOperation);
      setSelectHolidayOperation(holidayOperationData);

      //adding after clear value
      setDescription('');
      setSelectLeaveType({ id: null, description: '' });
      setDayLeaveType('');
    }
  };

  const removeLeave = (item) => {
    const realData = [...selectHoliday];
    const localData = [...selectHolidayLocal];
    const holidayOperationData = [...selectHolidayOperation];

    const filterHolidayType = realData.filter(
      (data) => data.calendarTypeId !== item.calendarTypeId
    );

    const filterHolidayTypeLocal = localData.filter(
      (data) => data.calendarTypeId !== item.calendarTypeId
    );

    //update purpose
    const filterHolidayOperation = holidayOperationData.filter((element: any) => {
      if (element.calendarTypeId === item.calendarTypeId) {
        if (element.Operation === 'Update') {
          element.Operation = 'Delete';
          return true;
        } else {
          return false;
        }
      }
      return true;
    });

    setSelectHoliday([...filterHolidayType]);
    setSelectHolidayLocal([...filterHolidayTypeLocal]);
    setSelectHolidayOperation([...filterHolidayOperation]);
  };

  const onSubmit = () => {
    if (selectHoliday) {
      if (props.isEdit) {
        updateCompanyLeave(selectHolidayOperation)
          .then((res) => {
            dispatch(
              AppActions.toggleSnackBarOpen({
                message: 'Holiday Updated Successfully',
                severity: 'success'
              })
            );
            handleClose();
            setSelectHoliday([]);
            setSelectHolidayLocal([]);
            setSelectHolidayOperation([]);
            setOpenConfirmation(false);
          })
          .catch((e) => {
            dispatch(
              AppActions.toggleSnackBarOpen({
                message: 'Unable to Update the Holiday',
                severity: 'error'
              })
            );
            handleClose();
            setSelectHoliday([]);
            setSelectHolidayLocal([]);
            setSelectHolidayOperation([]);
            setOpenConfirmation(false);
          });
      }else {
        addCompanyLeave(selectHoliday)
        .then((res) => {
          handleClose();
          dispatch(
            AppActions.toggleSnackBarOpen({
              message: 'You have added a holiday successfully',
              severity: 'success'
            })
          );
          setSelectHoliday([]);
          setSelectHolidayLocal([]);
          setOpenConfirmation(false);
        })
        .catch((e) => {
          handleClose();
          dispatch(
            AppActions.toggleSnackBarOpen({
              message: 'Unable to Add the Holiday',
              severity: 'error'
            })
          );
          setSelectHoliday([]);
          setSelectHolidayLocal([]);
          setOpenConfirmation(false);
        });
      }
    }
  };

  useEffect(() => {
    if (props.show) {
      setShowModal(props.show);
    }
  }, [props.show]);

  const handleClose = () => {
    setDescription('');
    setSelectLeaveType({ id: null, description: '' });
    setDayLeaveType('');
    setSelectHoliday([]);
    setSelectHolidayLocal([]);
    setSelectHolidayOperation([]);
    setErrors((prev) => ({
      ...prev,
      nameError: '',
      dayTypeError: '',
      leaveTypeError: ''
    }));
    setShowModal(false);
    props.handleClose();
  };
  const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    width: '50rem',
    transform: 'translate(-50%, -50%)',
    bgcolor: 'background.paper',
    border: '0px',
    boxShadow: 24,
    p: 4
  };

  const TextFieldStyle = {
    paddingTop: 2,
    paddingLeft: 15,
    paddingRight: 15
  };

  const LabelStyle = {
    paddingLeft: 15,
    paddingRight: 15
  };

  const selectStyle = {
    width: '89%',
    marginLeft: 10,
    marginTop: 3,
    paddingRight: 15,
    fontSize: '13px',
    height: '38px'
  };

  useEffect(() => {
    getLeaveType();
  }, []);

  const getLeaveType = () => {
    getLeaveTypes().then((res) => {
      setLeaveTypes(res?.data);
    });
  };

  return (
    <Modal
      open={showModal}
      onClose={handleClose}
      onBackdropClick={handleClose}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <Box sx={style}>
        <Typography
          id="modal-modal-title"
          variant="h5"
          component="h2"
          sx={{ ml: '1rem' }}
        >
          {props.isEdit ? 'Update' : 'Add'} Company Holiday - {moment(props.date).format('Do MMMM YYYY')}
        </Typography>
        <Grid style={{ display: 'flex', marginTop: '1rem' }}>
          <Grid xs={12} md={4}>
            <Typography style={LabelStyle} fontWeight="light" variant="h5">
              Holiday Type<span style={{ color: 'red' }}>*</span>
            </Typography>
            <Select
              MenuProps={{ autoFocus: false }}
              labelId="search-select-label"
              className="select-text"
              style={selectStyle}
              size="small"
              displayEmpty
              inputProps={{ 'aria-label': 'Without label' }}
              defaultValue={''}
              value={selectLeaveType.id || ''}
              onChange={(e) => {
                const selectedOption = leaveTypes.find(option => option.id === e.target.value);
                setSelectLeaveType(selectedOption || { id: null, description: '' });
                if (e.target.value) {
                  setErrors((prev) => ({
                    ...prev,
                    leaveTypeError: ''
                  }));
                }
              }}
            >
              <MenuItem
                style={{ display: 'none' }}
                selected
                disabled
                value={''}
              >
                Select Holiday Type
              </MenuItem>
              {leaveTypes?.map((option, i) => (
                <MenuItem key={i} value={option.id}>
                  {option.description}
                </MenuItem>
              ))}
            </Select>
            {errors.leaveTypeError && (
              <Typography
                style={{
                  paddingLeft: 15,
                  paddingRight: 15,
                  fontSize: '11px'
                }}
                color="red"
              >
                {errors.leaveTypeError}
              </Typography>
            )}
          </Grid>
          <Grid xs={12} md={4}>
            <Typography style={LabelStyle} fontWeight="light" variant="h5">
              Description<span style={{ color: 'red' }}>*</span>
            </Typography>
            <TextField
              value={description}
              size="small"
              style={TextFieldStyle}
              fullWidth
              placeholder="Enter Description"
              variant="outlined"
              onChange={(e) => {
                if (e.target.value.length > 30) {
                  setErrors((prev) => ({
                    ...prev,
                    nameError: 'Character length should not exceed 30'
                  }));
                } else {
                  setErrors((prev) => ({
                    ...prev,
                    nameError: ''
                  }));
                }
                setDescription(e.target.value);
              }}
            />
            {errors?.nameError && (
              <Typography
                style={{
                  paddingLeft: 15,
                  paddingRight: 15,
                  fontSize: '11px'
                }}
                color="red"
              >
                {errors?.nameError}&nbsp;
              </Typography>
            )}
          </Grid>
          <Grid xs={12} md={4}>
            <Typography style={LabelStyle} fontWeight="light" variant="h5">
              Day Type<span style={{ color: 'red' }}>*</span>
            </Typography>
            <Select
              MenuProps={{ autoFocus: false }}
              labelId="search-select-label"
              className="select-text"
              style={selectStyle}
              size="small"
              displayEmpty
              inputProps={{ 'aria-label': 'Without label' }}
              defaultValue={''}
              value={selectDayType}
              onChange={(e) => {
                setDayLeaveType(e.target.value);
                if (e.target.value) {
                  setErrors((prev) => ({
                    ...prev,
                    dayTypeError: ''
                  }));
                }
              }}
            >
              <MenuItem
                style={{ display: 'none' }}
                selected
                disabled
                value={''}
              >
                Select Day Type
              </MenuItem>
              {dayTypes?.map((option, i) => (
                <MenuItem key={i} value={option.value}>
                  {option.label}
                </MenuItem>
              ))}
            </Select>
            {errors.dayTypeError && (
              <Typography
                style={{
                  paddingLeft: 15,
                  paddingRight: 15,
                  fontSize: '11px'
                }}
                color="red"
              >
                {errors.dayTypeError}
              </Typography>
            )}
          </Grid>
          <Grid xs={12} md={1}>
            <Button
              disabled={
                !(
                  selectLeaveType.id &&
                  description.trim() &&
                  selectDayType &&
                  description.length < 31
                )
              }
              variant="contained"
              color="primary"
              sx={{ mt: 3 }}
              onClick={addLeave}
            >
              Add
            </Button>
          </Grid>
        </Grid>
        {selectHoliday.length !== 0 && (
          <>
            {selectHolidayLocal.map((item) => (
              <Grid style={{ display: 'flex', marginTop: '1rem' }}>
                <Grid xs={12} md={4}>
                  <TextField
                    disabled
                    size="small"
                    sx={{ pl: 1, pr: 2 }}
                    fullWidth
                    variant="outlined"
                    value={item.calendarType}
                  />
                </Grid>
                <Grid xs={12} md={4}>
                  <TextField
                    disabled
                    size="small"
                    sx={{ pl: 1.5, pr: 2 }}
                    fullWidth
                    variant="outlined"
                    value={item.description}
                  />
                </Grid>
                <Grid xs={12} md={4}>
                  <TextField
                    disabled
                    size="small"
                    sx={{ pl: 1, pr: 2.5 }}
                    fullWidth
                    variant="outlined"
                    value={item.dayType}
                  />
                </Grid>
                <Grid
                  xs={12}
                  md={1}
                  sx={{ display: 'flex', justifyContent: 'flex-end' }}
                >
                  <CancelIcon
                    style={{
                      color: 'gray',
                      fontSize: '1.5rem',
                      cursor: 'pointer'
                    }}
                    onClick={() => removeLeave(item)}
                  />
                </Grid>
              </Grid>
            ))}
          </>
        )}
        <Grid
          style={{
            display: 'flex',
            marginTop: '1rem',
            justifyContent: 'flex-end'
          }}
        >
          <Grid sx={{ mr: '1rem' }}>
            <Button sx={{ width: '5rem' }} onClick={handleClose}>
              Cancel
            </Button>
          </Grid>
          <Grid>
            <Button
              sx={{ width: '5rem'}}
              variant="contained"
              color="primary"
              disabled={selectHoliday.length === 0}
              onClick={() => toggleConfirmation()}
            >
              {props.isEdit ? 'Update' : 'Save'}
            </Button>
          </Grid>
        </Grid>
        <ConfirmationModal
          isLoading={isLoading}
          open={openConfirmation}
          toggle={toggleConfirmation}
          message={`Are you sure you want to ${props.isEdit ? 'update' : 'add'} this holiday?`}
          onConfirm={() => onSubmit()}
          noToggle={toggleConfirmation}
        />
      </Box>
    </Modal>
  );
};
export default AddLeaveModal;
